import { GraphQLTypes } from "kw/api/zeus";
import { useAPI } from "kw/api/useAPI";
import { useEffect, useState } from "react";

export const usePaymentMethod = () => {
  const { query } = useAPI();
  const [paymentMethod, setPaymentMethod] =
    useState<GraphQLTypes["PaymentMethodType"]>();
  const [refresh, setRefresh] = useState(false);

  const paymentMethodQuery = {
    paymentMethod: {
      cardNumber: true,
      cardType: true,
      expiryDate: true,
    },
  };

  useEffect(() => {
    query(
      paymentMethodQuery,
      (response: { paymentMethod: GraphQLTypes["PaymentMethodType"] }) => {
        setPaymentMethod(response.paymentMethod);
      },
      {}
    );
  }, [refresh]);

  return { paymentMethod, setRefresh, refresh };
};
